module.exports = __webpack_public_path__ + "static/media/icon_191.8bf0d3c4.svg";